import config from 'app/config'
import api from 'common/helpers/api'


export const getValidSurveys = () => {
    return api.get(`${config.API_URL}/surveys/`)
}